import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gs0054',
    ecrans: ['00-2']
});
